const feedbackdata=[
    {
        id:1,
        rating:9,
        text:'This is not good'
    },
    {
        id:2,
        rating:6,
        text:'This is not doing good.Should use better recepies'
    },
    {
        id:3,
        rating:7,
        text:'This is clearly the worst'
    }
]
export default feedbackdata;